import React, {Component} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import posed from 'react-pose';
import {Line as ProgressLine} from 'rc-progress';
import FontAwesome from 'react-fontawesome';
import Header from '../components/Header';
import MusicContentCard from '../components/MusicContentCard';
import {
  doMusicSearch,
  doAdvancedMusicSearch,
  resetSearchResults,
  resetSearch,
  searchPerformed,
  clearAdvancedTrackData,
  setCurrentTrack,
  showAdvancedData
} from '../store/actions';

const WrapperDiv = styled.div `
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-rows: 100px auto 75px;
  grid-row-gap: 5rem;
  grid-template-areas:
    'header header header'
    'body body body'
    'footer footer footer';
`;

const BodyWrapper = styled.div `
  grid-area: body;
  text-align: center;
  display: ${props => props.style.hideDisplay};
  position: relative;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - (175px + 10rem));
  @media (max-width: 700px) {
    min-height: calc(100vh - 175px);
  }
`;

const StyledContentardAvatar = styled.div `
  border solid 3px #340810;
  border-radius: 5px
  margin: 8px;
  height: 20rem;
  width: 20rem;
  align-items: center;
  justify-content: center;
  align-text: center;
  line-height: 5rem;
  display: flex;
  position: relative;
  &:after {
    content: '';
    background-color: black;
    background-image: url('${props => props.src.url}');
    background-repeat: no-repeat;
    background-size: cover;
    opacity: 1;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: -1;
  }
  @media (max-width: 700px) {
    height: 10rem;
    width: 10rem;
  }
`;

const TitleText = styled.p `
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-size: 2rem;
  text-align: center;
  margin-top: 0;
  width: 75%;
  @media (max-width: 700px) {
    font-size: 2rem;
  }
`;

const ArtistNameText = styled.p `
  font-family: 'Open Sans', sans-serif;
  font-size: 1.5rem;
  font-weight: 300;
  text-align: center;
`;

const Line = styled.hr `
  border: 0;
  width: 90%;
  border-top: 1px solid rgba(255,255,255,0.87);
`;

const BodyText = styled.p `
  font-family: 'Open Sans', sans-serif;
  > strong {
    color: #580f0f;
    margin-right: 2rem;
    margin-left: 2rem;
  }
`;
/*
const StyledProgressLine = styled(ProgressLine)`
  width: 90%;
  height: 2px;
`;

const StyledTimelineTextDiv = styled.div`
  width: 90%;
  display: flex;
  justify-content: space-between;
`;
*/
const PlayIconCircle = styled.button `
  position: relative;
  height: 6rem;
  width: 6rem;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  transition: all 0.5s;
  &:focus {
    outline: none;
  }
  &:hover {
    -webkit-box-shadow: 1px 1px 5px 0px rgba(255, 255, 255, 1);
    -moz-box-shadow: 1px 1px 5px 0px rgba(255, 255, 255, 1);
    box-shadow: 1px 1px 5px 0px rgba(255, 255, 255, 1);
    opacity: 0.5;


`;

const PlayIcon = styled(FontAwesome)`
  position: absolute;
  font-size: 4rem;
  line-height: 6rem;
  color: #af1230;
  left: ${props => props.cssleft};
`;

const StyledContentCardContent = styled.div `
  width: 70%;
  max-width: 500px;
  border-radius: 5px;
  margin: 8px;
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 0px;
  @media (max-width: 700px) {
    width: 90%;
  }
`;

const StyledContentTextHeader = styled.h4 `
  display: block;
  font-weight: 400;
  font-family: 'Open Sans', sans-serif;
  color: rgba(255,255,255,0.87);
  margin-top: 0rem;
`;

const StyledContentTextMiddle = styled.h3 `
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  line-height: 1.75rem;
  font-weight: 300;
  margin-bottom: 0.5rem;
  font-family: 'Open Sans', sans-serif;
`;

const StyledTimelineText = styled.p `
  display: block;
  line-height: 1px;
  font-size: 0.7em;
`;

const StyledProgressLine = styled(ProgressLine)`
  width: 90%;
  height: 2px;
`;

const StyledTimelineTextDiv = styled.div `
  width: 90%;
  display: flex;
  justify-content: space-between;
`;

const HeaderTextconfig = {
  visible: {
    opacity: 1,
    scale: 1
  },
  hidden: {
    opacity: 0,
    scale: 0
  },
  transition: {
    duration: 0
  }
};

const StyledSpinner = styled.div `
  margin-top: 10vh;
  width: 100vw;
  height: 25vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const PosedSearchResultsDiv = posed.div(HeaderTextconfig);

const StyledPosedSearchResultsDiv = styled(PosedSearchResultsDiv)`
  margin-top: 3rem;
  display: grid;
  grid-template-columns: 374px 374px;
  grid-template-rows: minmax(max-content, max-content);
  grid-auto-rows: minmax(max-content, max-content);
  grid-gap: 1rem;
  @media (max-width: 700px) {
    grid-template-columns: 90vw;
  }
`;

// const PosedGroupItem = posed.div({   enter: {     opacity: 1   },   exit: {
// opacity: 0   } });

class Track extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true,
      previewUrl: false,
      previewUrlSet: false,
      displaySearchResults: true,
      playPauseIcon: 'far fa-play',
      songProgress: 0,
      playIconLeft: '1.75rem',
      firstMount: true,
      firstAutoPlay: false,
      populatedTrackInfo: false,
      intervals: []
    };
    this.interval = null;
  }

  componentDidMount() {
    Promise
      .resolve(this.props.player.repopulateTrack())
      .then(() => this.props.player.keepPlayingTrack())
    // if(audioPlayerState){   console.log('SONG SRC', audioPlayerState.songSrc)
    // if(audioPlayerState.domRef){     this.props.player.playAudio()   } }
    // this.props.player.playAudio()

    this
      .props
      .showAdvancedData(true)
    // this._passBackTrack()
  }

/**
 *
 *
 * @param {*} prevProps
 * @memberof Track
 */
componentDidUpdate(prevProps) {
    console.debug('Track Component->componentDidUpdate: Updated!');
    const {success, advancedSuccess} = this.props.music;
    const {
      currentTrackBasicData,
      audioPlayerState: {
        trackID,
        componentPlaying,
        domRef
      }
    } = this.props.music;
    if (success) {
      if (currentTrackBasicData.preview_url && !this.state.previewUrlSet) {
        console.debug('Track Component->componentDidUpdate:  Updating current track preview information')
        this.setState({previewUrl: currentTrackBasicData.preview_url, previewUrlSet: true});
        // this.props.player.playAudio()
      }
      if (currentTrackBasicData.id !== prevProps.music.currentTrackBasicData.id) {
        console.debug('Track Component->componentDidUpdate: Updating current track preview and playing ' +
            'song')
        this.setState({previewUrl: currentTrackBasicData.preview_url})
        this
          .props
          .player
          .playAudio()
      }

      if (prevProps.music.audioPlayerState.trackID !== trackID && componentPlaying === 'track') {
        console.debug('Track Component->componentDidUpdate:  Updating track')
        this
          .props
          .player
          .updateAudioProgressUntilDone({
            state: {
              songProgress: 0,
              playPauseIcon: 'far fa-play'
            }
          });
      }

      if (prevProps.music.audioPlayerState.componentPlaying === 'footer' && componentPlaying === 'track') {
        console.debug('Track Component->componentDidUpdate:  Playing audio')
        this
          .props
          .player
          .playAudio()
      }

    }
    if (advancedSuccess && !this.state.populatedTrackInfo) {
      console.debug('Track Component->componentDidUpdate:  Updating current track information')
      this.setState({populatedTrackInfo: true});
      this
        .props
        .player
        .passBackTrack();
    }

    /**
     * If the track changed
    */
    if (prevProps.location.search !== this.props.location.search) {
      console.debug('Track Component->componentDidUpdate:  Resetting song');
      const state = {
        songProgress: 0,
        playPauseIcon: 'far fa-play'
      };
      this.setState(state);
      this
        .props
        .player
        .updateAudio(state);
      Promise
        .resolve(this.props.player.repopulateTrack())
        .then(() => this.props.player.keepPlayingTrack())
    }
    const a = domRef();
    /**
     * If the track is actually playing and we're not updating the progress then update it.
     * This happens if we start playing a track on another track page then navigate here
     */
    if (a && !a.paused && this.state.songProgress === 0) {
      this
        .props
        .player
        .handleProgress(a, this);
    }
  }

  componentWillUnmount() {
    const {
      music: {
        currentTrackBasicData,
        audioPlayerState,
        currentTrackAdvancedData,
        success
      }
    } = this.props;

    this
      .props
      .searchPerformed(true)
    this
      .props
      .showAdvancedData(false)
    // resetSearchResults();
    const a = audioPlayerState.domRef();

    let trackInfo = {
      trackID: success
        ? currentTrackBasicData.id
        : currentTrackAdvancedData.meta.data.id,
      playPause: 'play',
      showFooterPlayer: true,
      componentPlaying: 'footer'
    };
    if (!a.paused) {
      this
        .props
        .player
        .updateAudio(trackInfo);
    } else {
      this
        .props
        .player
        .resetAudio(trackInfo);
    }
  }

  _highlightIcon = color => {
    this.setState({playing: color});
  };

  _toggleHeaderText = () => {
    if (!this.props.music.success) {
      this.setState({
        displaySearchResults: !this.state.displaySearchResults
      });
      // doMusicSearch is a redux action that will do the actual search request to the
      // API and save the data in redux state
    }
    this
      .props
      .player
      .doMusicSearch();
  };

  _toggleHeaderTextVisibility = () => {
    this.setState({
      visible: !this.state.visible
    });
  };

  _renderContentCards = () => {
    const {currentTrackAdvancedData} = this.props.music;
    if (currentTrackAdvancedData) {
      const {items} = currentTrackAdvancedData;

      return items.map(i => <MusicContentCard key={i.id} item={i} player={this.props.player}/>);
    }
  };

  _songEnded = () => {
    this.setState({playPauseIcon: 'far fa-play', songProgress: 0, playIconLeft: '1.75rem'});
  };

  _handleAudioPlay = async() => {
    const {currentTrackAdvancedData, audioPlayerState} = this.props.music;
    const {domRef} = audioPlayerState;
    const a = domRef();
    if (currentTrackAdvancedData instanceof Object && currentTrackAdvancedData.meta.data) {
      const item = currentTrackAdvancedData.meta.data;
      /**
       * If the track was switched then we will definitely want to play the audio
       */
      if (item.id !== audioPlayerState.trackID) {
        console.log("Track Component:->_handleAudioPlay", item);

        await this
          .props
          .player
          .setCurrentTrack(item);
        this.setState({songProgress: 0});
        this
          .props
          .player
          .playAudio();
      } else {
        // Otherwise we want to handle the pause play behavior
        this
          .props
          .player
          .pausePlayAudio();
      }
    }
    if (a) {
      this
        .props
        .player
        .handleProgress(a, this);

      if (a.currentTime >= a.duration) {
        if (this.interval) {
          clearInterval(this.interval);
        }
      }
    }
  }

  _getAvatarSourceUrl = () => {
    const {currentTrackBasicData, currentTrackAdvancedData} = this.props.music;
    if (currentTrackAdvancedData) {
      if (currentTrackAdvancedData.meta.data.album) {
        return currentTrackAdvancedData.meta.data.album.image.url;
      }
    }
    return currentTrackBasicData.album.image.url;
  };

  _returnTrackPageBody = () => {
    const {displaySearchResults} = this.state;
    const {currentTrackBasicData, currentTrackAdvancedData, audioPlayerState, advancedSuccess} = this.props.music;

    console.debug("Track Component->_returnTrackPageBody", this.props.music);

    const {isPlaying} = audioPlayerState;
    const currentTrack = currentTrackAdvancedData instanceof Object && currentTrackAdvancedData.meta
      ? currentTrackAdvancedData.meta.data
      : currentTrackBasicData;
    let playIcon = audioPlayerState.playIcon,
      isCurrentTrack = currentTrack instanceof Object && currentTrack.id === audioPlayerState.trackID;
    if (isCurrentTrack) {
      playIcon = audioPlayerState.currentIcon;
    }

    if (!advancedSuccess) {
      return (
        <StyledSpinner>
          <div className='lds-roller'>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </StyledSpinner>
      );
    }
    return (
      <BodyWrapper
        style={{
        hideDisplay: this.props.auth.isLoggedIn
          ? !this.props.music.modalIsOpen
            ? 'flex'
            : 'none' : this.props.music.modalIsOpen
              ? 'none'
              : 'flex'
      }}>
        <StyledContentardAvatar
          src={{
          url: this._getAvatarSourceUrl
        }}>
          <PlayIconCircle
            onClick={() => this._handleAudioPlay()}
            style={{
            opacity: !audioPlayerState.songSrc
              ? '0.5'
              : '1'
          }}>
            {audioPlayerState.songSrc
              ? (<PlayIcon
                name={playIcon}
                cssleft={isPlaying && isCurrentTrack
                ? '1.35rem'
                : '1.75rem'}/>)
              : (
                <BodyText>Sample Unavailable</BodyText>
              )}
          </PlayIconCircle>
        </StyledContentardAvatar>
        <ArtistNameText>
          {currentTrackAdvancedData
            ? currentTrackAdvancedData.meta.data.artist
            : currentTrackBasicData.artist}
        </ArtistNameText>
        <TitleText>{currentTrackAdvancedData
            ? currentTrackAdvancedData.meta.data.title
            : 'Loading...'}</TitleText>
        <Line/>
        <StyledContentCardContent>
          <StyledContentTextMiddle>
            {currentTrackAdvancedData
              ? `${currentTrackAdvancedData.meta.data.camelot}`
              : `${currentTrackBasicData.camelot}`}
          </StyledContentTextMiddle>
          <StyledContentTextMiddle>
            {currentTrackAdvancedData && currentTrackAdvancedData.meta.data.key}
          </StyledContentTextMiddle>
          <StyledContentTextMiddle>
            {currentTrackAdvancedData && currentTrackAdvancedData.meta.data.features.energy}
          </StyledContentTextMiddle>
          <StyledContentTextHeader>Camelot</StyledContentTextHeader>
          <StyledContentTextHeader>Key</StyledContentTextHeader>
          <StyledContentTextHeader>BPM</StyledContentTextHeader>
        </StyledContentCardContent>

        <StyledProgressLine
          percent={isCurrentTrack
          ? this.state.songProgress
          : 0}
          strokeWidth='1'
          strokeColor='#580f0f'/>
        <StyledTimelineTextDiv>
          <StyledTimelineText>{isCurrentTrack
              ? this.state.currentTime
              : '0:00'}</StyledTimelineText>
          <StyledTimelineText>0:30</StyledTimelineText>
        </StyledTimelineTextDiv>
        <ArtistNameText>Cue Recommendations</ArtistNameText>
        <StyledPosedSearchResultsDiv
          pose={displaySearchResults
          ? 'visible'
          : 'hidden'}
          onPoseComplete={this._toggleHeaderTextVisibility}>
          {currentTrackAdvancedData && this._renderContentCards()}
        </StyledPosedSearchResultsDiv>
      </BodyWrapper>
    );
  };

  render() {
    return (
      <WrapperDiv>
        <Header/> {this._returnTrackPageBody()}
      </WrapperDiv>
    );
  }
}

const mapStateToProps = state => ({music: state.music, auth: state.auth});

export default connect(mapStateToProps, {
  doMusicSearch,
  doAdvancedMusicSearch,
  resetSearchResults,
  resetSearch,
  searchPerformed,
  clearAdvancedTrackData,
  setCurrentTrack,
  showAdvancedData
})(Track);



// WEBPACK FOOTER //
// ./src/screen/Track.js